import { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';

const getTodayString = () => {
  const now = new Date();
  const shifted = new Date(now.getTime() + (3 * 60 * 60 * 1000));
  return shifted.toISOString().slice(0, 10);
};

export const useWinningArchive = () => {
  const [analyses, setAnalyses] = useState([]);
  const [counts, setCounts] = useState({ analyses: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(getTodayString());

  const fetchArchive = useCallback(async (date = selectedDate) => {
    try {
      setLoading(true);
      setError(null);
      const data = await api.getWinningArchive(48, date);
      setAnalyses(data.analyses || []);
      setCounts(data.counts || { analyses: 0 });
    } catch (err) {
      setError(err.message);
      setAnalyses([]);
    } finally {
      setLoading(false);
    }
  }, [selectedDate]);

  useEffect(() => {
    fetchArchive(selectedDate);
  }, [selectedDate, fetchArchive]);

  return {
    analyses,
    counts,
    loading,
    error,
    selectedDate,
    setSelectedDate,
    refetch: () => fetchArchive(selectedDate)
  };
};
